<template>
  <MatchMedia v-slot="{ matches: isDesktop }" device="desktop" class="footer">
    <div class="footer-content">
      <div>
        <BaseText size="sm" :color="NebraskaColors.textSecondary">
          Valor total a ser investido
        </BaseText>
        <Heading :level="3">{{ investmentValue | money }}</Heading>
        <BaseText
          v-if="errorMessage"
          size="sm"
          :color="NebraskaColors.textOnError"
          class="footer__error"
        >
          {{ errorMessage }}
        </BaseText>
      </div>
      <div>
        <ButtonPrimary
          v-if="isDesktop"
          :disabled="disabled"
          size="large"
          label="Investir"
          :loading="isLoading"
          @click="onButtonClick"
        />
        <ButtonIconPrimary
          v-else
          :disabled="disabled"
          icon="ic_arrow_right"
          label="Investir"
          :loading="isLoading"
          @click="onButtonClick"
        />
      </div>
    </div>
  </MatchMedia>
</template>

<script lang="ts">
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import {
  ButtonPrimary,
  Heading,
  BaseText,
  ButtonIconPrimary
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { moneyViewer as money } from '@/modules/common/helpers/currency';
import { MatchMedia } from '@/modules/common/components/MatchMedia';

@Component({
  name: 'Footer',
  components: {
    ButtonPrimary,
    Heading,
    BaseText,
    ButtonIconPrimary,
    MatchMedia
  },
  filters: { money }
})
export default class Footer extends Vue {
  private NebraskaColors = NebraskaColors;
  @Prop({ type: Boolean, default: false })
  public disabled?: boolean;

  @Prop({ type: Boolean, default: false })
  public isLoading!: boolean;

  @Prop({ type: Number, required: true })
  public investmentValue!: number;

  @Prop({ type: String, required: false })
  public errorMessage?: string;

  @Emit()
  private onButtonClick() {}
}
</script>

<style lang="less" scoped>
.footer {
  z-index: 2;
  background-color: @background-secondary;
  border-top: 1px solid @divider-primary;
  padding: @size-spacing-x500 @size-spacing-x400;
}
.footer-content {
  max-width: 1008px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.footer__error {
  margin-top: @size-spacing-x150;
}
</style>
